import React, { useEffect, useState } from "react";
import { getMap } from "../api/client";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconAnchor: [12, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

const MapPage = ({ settings, lang }) => {
    const [branches, setBranches] = useState([]);
    const [filteredBranches, setFilteredBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getMap();
                setBranches(response.data || []);
                setFilteredBranches(response.data || []);
            } catch (error) {
                console.error("Failed to fetch map data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleSearch = (e) => {
        const term = e.target.value.toLowerCase();
        setSearchTerm(term);
        const filtered = branches.filter(b => {
            const nameEn = b.branchName?.en?.toLowerCase() || "";
            const nameAr = b.branchName?.ar?.toLowerCase() || "";
            const cityEn = b.city?.en?.toLowerCase() || "";
            const cityAr = b.city?.ar?.toLowerCase() || "";
            return nameEn.includes(term) || nameAr.includes(term) || cityEn.includes(term) || cityAr.includes(term);
        });
        setFilteredBranches(filtered);
    };

    const getStatic = (key, fallback) => {
        const staticData = lang === "en" ? settings.en : settings.ar;
        return (staticData && staticData[key]) ? staticData[key] : fallback;
    }

    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };

    useEffect(() => {
        document.title = getStatic("page_title_map", "إينوبريدج - فروعنا");

        // Update meta description
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
            metaDesc.setAttribute("content", getStatic("meta_description_map", "إينوبريدج - فروعنا"));
        }

        // Update meta keywords
        const metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
            metaKeywords.setAttribute("content", getStatic("meta_keyword_map", "إينوبريدج - فروعنا"));
        }
    }, [lang, settings]);
    const getText = (en, ar) => (lang === "en" ? en : ar);


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader

    return (
        <>
            <header className="py-5 bg-body header header1">
                <div className="container py-5 text-center">
                    <div className="layout-h"></div>
                    <h1 className="display-4 fw-bold mb-3" data-aos="fade-up">
                        {getText("Global Presence", "التواجد العالمي")}
                    </h1>
                    <p className="lead text-muted mx-auto" style={{ maxWidth: '700px' }} data-aos="zoom-in" data-aos-delay="100">
                        {getText("Explore our offices and branches around the world.", "استكشف مكاتبنا وفروعنا حول العالم.")}
                    </p>
                </div>
            </header>

            <section className="py-5 bg-card">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-6 mx-auto">
                            <div className="input-group" dir="ltr">
                                <span className="input-group-text bg-card border-end-0">
                                    <i className="ri-search-line"></i>
                                </span>
                                <input
                                    type="text"
                                    className="form-control border-start-0 bg-body"
                                    placeholder={getText("Search by country or city...", "ابحث عن طريق الدولة أو المدينة...")}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    dir={lang === 'ar' ? 'rtl' : 'ltr'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-custom p-1" style={{ height: '500px' }}>
                        <MapContainer center={[20, 0]} zoom={2} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
                            <TileLayer
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            />
                            {filteredBranches.map((loc, idx) => (
                                <Marker key={idx} position={[parseFloat(loc.lat), parseFloat(loc.lng)]}>
                                    <Popup>
                                        <div className="text-center p-2">
                                            <h6 className="fw-bold mb-1">{lang === 'en' ? loc.branchName?.en : loc.branchName?.ar}</h6>
                                            <p className="small text-muted mb-2">
                                                {lang === 'en' ? loc.city?.en : loc.city?.ar}, {lang === 'en' ? loc.countryName?.en : loc.countryName?.ar}
                                            </p>
                                            <Link to={`/branch/${loc.slug_en}`} className="btn btn-sm btn-primary-custom py-1 px-2" style={{ fontSize: '0.8rem' }}>
                                                {getText("View Details", "عرض التفاصيل")}
                                            </Link>
                                        </div>
                                    </Popup>
                                </Marker>
                            ))}
                        </MapContainer>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-body">
                <div className="container">
                    <div className="text-center mb-5" data-aos="fade-up">
                        <h2 className="fw-bold">{getText("Our Offices", "مكاتبنا")}</h2>
                    </div>
                    <div className="row gy-4">
                        {loading ? (
                            <div className="col-12 py-5 text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            filteredBranches.length > 0 ? (
                                filteredBranches.map((loc, index) => (
                                    <div className="col-lg-3 col-md-6" data-aos="fade-up" key={index}>
                                        <div className="card-custom h-100 p-4 text-center bg-card">
                                            <div className="mb-3 text-primary"><i className="ri-map-pin-line fs-2"></i></div>
                                            <h5 className="fw-bold mb-2">{lang === 'en' ? loc.branchName?.en : loc.branchName?.ar}</h5>
                                            <p className="text-muted small mb-3">
                                                {lang === 'en' ? loc.city?.en : loc.city?.ar}, {lang === 'en' ? loc.countryName?.en : loc.countryName?.ar}
                                            </p>
                                            <Link to={`/branch/${loc.slug_en}`} className="btn btn-outline-custom btn-sm w-100">
                                                {getText("View Details", "عرض التفاصيل")}
                                            </Link>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12" data-aos="fade-up">
                                    <div className="card-custom h-100 py-5 overflow-hidden group text-center bg-body">
                                        <p className="m-0">{getText("There is no locations found.", "لا توجد مواقع.")}</p>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default MapPage;
